const defaultSxProp = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {};

export { defaultSxProp };
